/**
 * Admin Data Helpers
 * 
 * Separate storage for admin authentication.
 * Admin tokens use 'adminToken' key, completely separate from user 'token'.
 */

// Storage keys for admin - SEPARATE from user storage
const ADMIN_STORAGE_KEYS = {
  TOKEN: 'adminToken',
  ADMIN_DATA: 'adminData',
}

/**
 * Get admin auth token from localStorage
 */
export const getAdminToken = () => {
  return localStorage.getItem(ADMIN_STORAGE_KEYS.TOKEN)
}

/**
 * Save admin auth token
 * @param {string} token - JWT token
 */
export const saveAdminToken = (token) => {
  localStorage.setItem(ADMIN_STORAGE_KEYS.TOKEN, token)
}

/**
 * Get cached admin data from localStorage
 */
export const getAdminData = () => {
  const data = localStorage.getItem(ADMIN_STORAGE_KEYS.ADMIN_DATA)
  if (data) {
    try {
      return JSON.parse(data)
    } catch (e) {
      console.error('Error parsing admin data:', e)
    }
  }
  return null
}

/**
 * Save admin data to localStorage
 * @param {object} adminData - Admin data from API
 */
export const saveAdminData = (adminData) => {
  localStorage.setItem(ADMIN_STORAGE_KEYS.ADMIN_DATA, JSON.stringify(adminData))
}

/**
 * Save admin auth data (token + admin data)
 * @param {string} token - JWT token
 * @param {object} adminData - Admin data
 */
export const saveAdminAuth = (token, adminData) => {
  saveAdminToken(token)
  if (adminData) {
    saveAdminData(adminData)
  }
}

/**
 * Clear all admin auth data (logout)
 */
export const clearAdminAuth = () => {
  localStorage.removeItem(ADMIN_STORAGE_KEYS.TOKEN)
  localStorage.removeItem(ADMIN_STORAGE_KEYS.ADMIN_DATA)
}

/**
 * Check if admin is authenticated
 */
export const isAdminAuthenticated = () => {
  return !!getAdminToken()
}

/**
 * Get admin from cached data
 */
export const getAdmin = () => {
  const adminData = getAdminData()
  if (!adminData) return null
  
  // Support both flat and nested formats
  if (adminData.admin) {
    return adminData.admin
  }
  return adminData
}

/**
 * Get admin ID from cached data
 */
export const getAdminId = () => {
  const admin = getAdmin()
  return admin?.id || null
}

// Export storage keys for components that need direct access
export { ADMIN_STORAGE_KEYS }

